import Vue from "vue";
import VueScroller from 'vue-scroller'
import App from "../components/App.vue";
import router from '../router';

Vue.use(VueScroller);


export default function home() {
  new Vue({
    el: "#app",
    router,
    template: "<App/>",
    components: {
      App
    }
  });
}



// WEBPACK FOOTER //
// ./feature/home.js